import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M14 11h-4v4H9v-4H5v-1h4V6h1v4h4v1zM9.5 4C5.916 4 3 6.916 3 10.5S5.916 17 9.5 17s6.5-2.916 6.5-6.5S13.084 4 9.5 4zm0-1c4.125 0 7.5 3.375 7.5 7.5S13.625 18 9.5 18 2 14.625 2 10.5 5.375 3 9.5 3z',
  ],
  height: 20,
  width: 20,
});
